import React, { FunctionComponent, useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import useServerConnected from '../../hooks/ui/useServerConnected'
import { App, Badge, Typography } from 'antd'
import { orange, red } from '@ant-design/colors'
import { useNavigate } from '@tanstack/react-router'

const StyledContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
  z-index: 4;
`

const ServerStatus: FunctionComponent<any> = () => {
  const connected = useServerConnected()
  const restartRef = useRef(false)
  const navigate = useNavigate()

  const { notification } = App.useApp()

  // If server is down for more than five seconds, refresh the page
  useEffect(() => {
    let timeout
    let navigateTimeout
    if (!connected) {
      timeout = setTimeout(() => {
        notification.info({
          message: 'Restarting for an update.',
          duration: 3
        })
        restartRef.current = true
      }, 3000)
      // Navigate timeout
      navigateTimeout = setTimeout(() => {
        navigate({ to: '/login' })
      }, 1000 * 15)
    } else {
      if (restartRef.current) {
        notification.info({
          message: 'Refreshing page...',
          duration: 3
        })
        timeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
      }
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
      if (navigateTimeout) {
        clearTimeout(navigateTimeout)
      }
    }
  }, [connected, navigate, notification])

  return (
    <StyledContainer>
      <Badge.Ribbon
        text={<Typography.Text>{`Server: ${connected ? 'Online' : 'Offline'}`}</Typography.Text>}
        color={connected ? orange[5] : red[5]}
      />
    </StyledContainer>
  )
}

export default ServerStatus
